export default "__VITE_ASSET__BSNibOgn__"